// ============================================
// SERVICE CANDIDAT
// ============================================

import api from './api';

const candidateService = {
    // Obtenir le profil candidat
    getProfile: async () => {
        try {
            const response = await api.get('/api/candidate/profile');
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la récupération du profil' };
        }
    },

    // Créer le profil candidat
    createProfile: async (profileData) => {
        try {
            const response = await api.post('/api/candidate/profile', profileData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la création du profil' };
        }
    },

    // Mettre à jour le profil candidat
    updateProfile: async (profileData) => {
        try {
            const response = await api.put('/api/candidate/profile', profileData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la mise à jour du profil' };
        }
    },

    // Obtenir le tableau de bord
    getDashboard: async () => {
        try {
            const response = await api.get('/api/candidate/dashboard');
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la récupération du tableau de bord' };
        }
    },

    // Obtenir les candidatures
    getApplications: async () => {
        try {
            const response = await api.get('/api/applications');
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la récupération des candidatures' };
        }
    },

    // Obtenir une candidature spécifique
    getApplication: async (id) => {
        try {
            const response = await api.get(`/api/applications/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la récupération de la candidature' };
        }
    },

    // Créer une candidature
    createApplication: async (applicationData) => {
        try {
            const response = await api.post('/api/applications', applicationData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la création de la candidature' };
        }
    },

    // Mettre à jour une candidature
    updateApplication: async (id, applicationData) => {
        try {
            const response = await api.put(`/api/applications/${id}`, applicationData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la mise à jour de la candidature' };
        }
    },

    // Soumettre une candidature
    submitApplication: async (id) => {
        try {
            const response = await api.post(`/api/applications/${id}/submit`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la soumission de la candidature' };
        }
    },

    // Obtenir les annonces
    getAnnouncements: async () => {
        try {
            const response = await api.get('/api/announcements');
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la récupération des annonces' };
        }
    }
};

export default candidateService;

